<template>
    <vx-card :title="'Canvas Return Putaway'">
        <div class="vx-row mb-6" style="width: 50%">
            <vs-button class="ml-4 mt-2" color="danger" icon-pack="feather" icon="icon-arrow-left"
                @click="handleBack()">Back</vs-button>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Item Request Document</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="reqCode" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Handover Document</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="handoverCode" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Unloading Document</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="unlCode" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Territory</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="territories" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Warehouse</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="warehouse ? warehouse.label : ''" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Sales</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="sales" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Request Date</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="requestDate" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Loading Date</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="loadingDate" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Unloading Date</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="unloadingDate" :readonly="true" class="w-full"></vs-input>
            </div>
        </div>
        <br>
        <div class="vx-row mb-6">
            <div class="vx-col w-full">
                <h4>Putaway's Reference</h4>
                <hr>
                <br>
                <table width="100%" class="vs-table vs-table--tbody-table">
                    <thead class="vs-table--thead">
                        <tr>
                            <th>SKU Description</th>
                            <th>Batch</th>
                            <th width="10%">Quantity (UOM)</th>
                            <th width="10%">UOM</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(tr, index) in referenceDataLines">
                            <tr style="padding-bottom: 5px;" :key="index">
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="tr.add_line.length">
                                    <vs-input :value="tr.item_name" :readonly="true" class="w-full"></vs-input>
                                </td>

                                <!-- first row -->
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].batch" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].qty" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].uom" :readonly="true" class="w-full"></vs-input>
                                </td>
                            </tr>

                            <!-- add lines -->
                            <template v-for="(addLine, idx) in tr.add_line">
                                <tr style="padding-bottom: 5px;" :key="index + '-' + idx" v-if="idx > 0">
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.batch" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.qty" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.uom" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <br>
        <div class="vx-row mb-6">
            <div class="vx-col w-full">
                <h4>Putaway Item Lines</h4>
                <hr>
                <br>
                <table width="100%" class="vs-table vs-table--tbody-table">
                    <thead class="vs-table--thead">
                        <tr>
                            <th width="30%">SKU Description</th>
                            <th width="7%">Unload Qty (UOM)</th>
                            <th width="12%">Status</th>
                            <th width="7%">Qty</th>
                            <th width="10%">Unit</th>
                            <th width="6%">Qty UOM</th>
                            <th width="15%">Batch</th>
                            <th width="15%">Warehouse Area</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(dataLine, index) in dataLines">
                            <!-- first row -->
                            <tr style="padding-bottom: 5px" :key="index">
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="dataLine.add_line.length">
                                    <vs-input :value="dataLine.item_name" readonly class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="dataLine.add_line.length">
                                    <vs-input :value="dataLine.ul_qty" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_status"
                                        v-model="dataLine.add_line[0].status"
                                        class="w-full"
                                        :clearable="false"
                                        @input="val => { onChangeStatus(val, index, 0); }"
                                    />
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <vs-input 
                                        type="text" 
                                        class="w-full" 
                                        v-model="dataLine.add_line[0].qty"
                                        @keypress="preventDecimal"
                                        @input="(val) => { onChangeQty('normal', index, 0, val); }"
                                    >
                                    </vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_unit"
                                        v-model="dataLine.add_line[0].unit"
                                        class="w-full"
                                        :clearable="false"
                                        @input="val => { onChangeHu('normal', index, 0, val) }"
                                    />
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <vs-input
                                        v-if="renderUom"
                                        type="number"
                                        class="w-full"
                                        readonly
                                        :min="0"
                                        v-model="dataLine.add_line[0].qty_uom">
                                    </vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_batch"
                                        v-model="dataLine.add_line[0].batch"
                                        class="w-full"
                                        :clearable="false"
                                    />
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.add_line[0].option_warehouse_area"
                                        v-model="dataLine.add_line[0].warehouse_area_code"
                                        class="w-full"
                                        :clearable="false"
                                        :disabled="dataLine.add_line[0].status == 'Not picked yet'"
                                    />
                                </td>
                                <td class="td vs-table--td align-top pt-2">
                                    <div class="vx-input-group flex mx-auto">
                                        <vs-button v-if="dataLine.add_line.length > 1"
                                            @click.stop="removeRow('normal', index, 0)" size="small" color="danger"
                                            icon-pack="feather" icon="icon-trash" style="margin-right: 5px"
                                            title="Remove Row" />
                                        <vs-button @click.stop="addRow('normal', index)" size="small" color="success"
                                            v-if="dataLine.add_line.length == 1" icon-pack="feather" icon="icon-plus"
                                            title="Add Row" />
                                    </div>
                                </td>
                            </tr>

                            <!-- add lines -->
                            <template v-for="(addLine, indexAddLine) in dataLines[index].add_line">
                                <tr style="padding-bottom: 5px;" :key="index + '-' + indexAddLine" v-if="indexAddLine > 0">
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_status"
                                            v-model="addLine.status"
                                            class="w-full"
                                            :clearable="false"
                                            @input="val => { onChangeStatus(val, index, indexAddLine) }"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <vs-input
                                            type="text"
                                            class="w-full"
                                            v-model="addLine.qty"
                                            @keypress="preventDecimal"
                                            @input="(val) => { onChangeQty('normal', index, indexAddLine, val); }"
                                        >
                                        </vs-input>
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_unit"
                                            v-model="addLine.unit"
                                            class="w-full"
                                            :clearable="false"
                                            @input="val => { onChangeHu('normal', index, indexAddLine, val) }"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <vs-input
                                            v-if="renderUom"
                                            type="number"
                                            class="w-full"
                                            :min="0"
                                            readonly
                                            v-model="addLine.qty_uom">
                                        </vs-input>
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_batch"
                                            v-model="addLine.batch"
                                            class="w-full"
                                            :clearable="false"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="addLine.option_warehouse_area"
                                            v-model="addLine.warehouse_area_code"
                                            class="w-full"
                                            :clearable="false"
                                            :disabled="addLine.status == 'Not picked yet'"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top pt-2">
                                        <div class="vx-input-group flex mx-auto">
                                            <vs-button v-if="dataLine.add_line.length > 0"
                                                @click.stop="removeRow('normal', index, indexAddLine)" size="small" color="danger"
                                                icon-pack="feather" icon="icon-trash" style="margin-right: 5px"
                                                title="Remove Row" />
                                            <vs-button @click.stop="addRow('normal', index)" size="small" color="success"
                                                v-if="dataLine.add_line.length == indexAddLine + 1"
                                                icon-pack="feather" icon="icon-plus" title="Add Row" />
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- ... -->
        <br>
        <div class="vx-row mb-6" v-if="referenceMissingLines.length > 0">
            <div class="vx-col w-full">
                <h4>Missing's Reference</h4>
                <hr>
                <br>
                <table width="100%" class="vs-table vs-table--tbody-table">
                    <thead class="vs-table--thead">
                        <tr>
                            <th>SKU Description</th>
                            <th>Batch</th>
                            <th width="10%">Quantity (UOM)</th>
                            <th width="10%">UOM</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(tr, index) in referenceMissingLines">
                            <tr style="padding-bottom: 5px;" :key="index">
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="tr.add_line.length">
                                    <vs-input :value="tr.item_name" :readonly="true" class="w-full"></vs-input>
                                </td>

                                <!-- first row -->
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].batch" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].qty" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td" style="padding: 5px">
                                    <vs-input :value="tr.add_line[0].uom" :readonly="true" class="w-full"></vs-input>
                                </td>
                            </tr>

                            <!-- add lines -->
                            <template v-for="(addLine, idx) in tr.add_line">
                                <tr style="padding-bottom: 5px;" :key="index + '-' + idx" v-if="idx > 0">
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.batch" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.qty" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                    <td class="td vs-table--td" style="padding: 5px">
                                        <vs-input :value="addLine.uom" :readonly="true" class="w-full"></vs-input>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <br>
        <div class="vx-row mb-6" v-if="missingDataLines.length > 0">
            <div class="vx-col w-full">
                <h4>Missing Item Lines</h4>
                <hr>
                <br>
                <table width="100%" class="vs-table vs-table--tbody-table">
                    <thead class="vs-table--thead">
                        <tr>
                            <th width="28%">SKU Description</th>
                            <th width="7%">Missing Qty (UOM)</th>
                            <th width="8%">Status</th>
                            <th width="7%">Qty</th>
                            <th width="10%">Unit</th>
                            <th width="7%">Qty UOM</th>
                            <th width="15%">Batch</th>
                            <th width="15%">Warehouse Area</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(dataLine, index) in missingDataLines">
                            <!-- first row -->
                            <tr style="padding-bottom: 5px" :key="index">
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="dataLine.add_line.length">
                                    <vs-input :value="dataLine.item_name" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="dataLine.add_line.length">
                                    <vs-input :value="dataLine.ul_qty" :readonly="true" class="w-full"></vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px" :rowspan="dataLine.add_line.length">
                                    <vs-input :value="dataLine.status" :readonly="true" class="w-full"></vs-input>
                                </td>

                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <vs-input
                                        type="text"
                                        class="w-full"
                                        v-model="dataLine.add_line[0].qty"
                                        @keypress="preventDecimal"
                                        @input="(val) => { onChangeQty('missing', index, 0, val); }"
                                    >
                                    </vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_unit"
                                        v-model="dataLine.add_line[0].unit"
                                        class="w-full"
                                        :clearable="false"
                                        @input="val => { onChangeHu('missing', index, 0, val) }"
                                    />
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <vs-input
                                        v-if="renderUom"
                                        type="number"
                                        class="w-full"
                                        :min="0"
                                        readonly
                                        v-model="dataLine.add_line[0].qty_uom">
                                    </vs-input>
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_batch"
                                        v-model="dataLine.add_line[0].batch"
                                        class="w-full"
                                        :clearable="false"
                                    />
                                </td>
                                <td class="td vs-table--td align-top" style="padding: 5px">
                                    <v-select
                                        :filterable="false"
                                        :options="dataLine.option_warehouse_area"
                                        v-model="dataLine.add_line[0].warehouse_area_code"
                                        class="w-full"
                                        :clearable="false"
                                    />
                                </td>
                                <td class="td vs-table--td align-top pt-2">
                                    <div class="vx-input-group flex mx-auto">
                                        <vs-button v-if="dataLine.add_line.length > 1"
                                            @click.stop="removeRow('missing', index, 0)" size="small" color="danger"
                                            icon-pack="feather" icon="icon-trash" style="margin-right: 5px"
                                            title="Remove Row" />
                                        <vs-button @click.stop="addRow('missing', index)" size="small" color="success"
                                            v-if="dataLine.add_line.length == 1" icon-pack="feather" icon="icon-plus"
                                            title="Add Row" />
                                    </div>
                                </td>
                            </tr>

                            <!-- add lines -->
                            <template v-for="(addLine, indexAddLine) in missingDataLines[index].add_line">
                                <tr style="padding-bottom: 5px;" :key="index + '-' + indexAddLine" v-if="indexAddLine > 0">
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <vs-input
                                            type="text"
                                            class="w-full"
                                            v-model="addLine.qty"
                                            @keypress="preventDecimal"
                                            @input="(val) => { onChangeQty('missing', index, indexAddLine, val); }"
                                        >
                                        </vs-input>
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_unit"
                                            v-model="addLine.unit"
                                            class="w-full"
                                            :clearable="false"
                                            @input="val => { onChangeHu('missing', index, indexAddLine, val) }"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <vs-input
                                            v-if="renderUom"
                                            type="number"
                                            class="w-full"
                                            :min="0"
                                            readonly
                                            v-model="addLine.qty_uom">
                                        </vs-input>
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_batch"
                                            v-model="addLine.batch"
                                            class="w-full"
                                            :clearable="false"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top" style="padding: 5px">
                                        <v-select
                                            :filterable="false"
                                            :options="dataLine.option_warehouse_area"
                                            v-model="addLine.warehouse_area_code"
                                            class="w-full"
                                            :clearable="false"
                                        />
                                    </td>
                                    <td class="td vs-table--td align-top pt-2">
                                        <div class="vx-input-group flex mx-auto">
                                            <vs-button v-if="dataLine.add_line.length > 0"
                                                @click.stop="removeRow('missing', index, indexAddLine)" size="small" color="danger"
                                                icon-pack="feather" icon="icon-trash" style="margin-right: 5px"
                                                title="Remove Row" />
                                            <vs-button @click.stop="addRow('missing', index)" size="small" color="success"
                                                v-if="dataLine.add_line.length == indexAddLine + 1"
                                                icon-pack="feather" icon="icon-plus" title="Add Row" />
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <br>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/1 w-full">
                <div style="
                    position: absolute;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                ">
                    <vs-button class="mr-3 mb-2" @click="handleSubmit">Save</vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="danger" v-on:click="handleBack">Back</vs-button>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
    },
    data() {
        return {
            id: null,
            readonly: true,
            reqCode: null,
            handoverCode: null,
            unlCode: null,
            territories: null,
            warehouse: null,
            sales: null,
            requestDate: null,
            loadingDate: null,
            unloadingDate: null,
            referenceDataLines : [
                {
                    unloading_id: 0,
                    item_code: null,
                    item_name: null,
                    add_line: [{
                        batch: null,
                        qty: 0,
                        uom: null,
                    }]
                }
            ],
            dataLines: [
                {
                    unloading_id: 0,
                    item_name: null,
                    item_code: null,
                    ul_selected_hu: null,
                    ul_qty: 0,
                    option_batch: [],
                    option_status: [],
                    option_unit: [],
                    add_line: [{
                        putaway_id: 0,
                        status: null,
                        qty: 0,
                        unit: null,
                        qty_uom: null,
                        batch: null,
                        option_warehouse_area: [],
                        warehouse_area_code: null,
                    }]
                }
            ],
            referenceMissingLines: [
                {
                    unloading_id: 0,
                    item_code: null,
                    item_name: null,
                    add_line: [{
                        batch: null,
                        qty: 0,
                        uom: null,
                    }]
                }
            ],
            missingDataLines: [
                {
                    unloading_id: 0,
                    item_name: null,
                    item_code: null,
                    ul_qty: 0,
                    status: null,
                    option_batch: [],
                    option_unit: [],
                    option_warehouse_area: [],
                    add_line: [{
                        putaway_id: 0,
                        qty: 0,
                        unit: null,
                        qty_uom: null,
                        batch: null,
                        warehouse_area_code: null,
                    }]
                }
            ],
            renderUom: true,
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id) {
            this.getData()
        }
    },
    methods: {
        handleUpdateFormat(value) {
            let cleanValue = value.toString().replace(/\D/g, '');
            return new Intl.NumberFormat('id-ID').format(cleanValue);
        },
        preventDecimal(event) {
            if (event.key === '.' || event.key === ',' || event.key === 'e' || event.key === '-' ) {
                event.preventDefault();
            }
        },
        getData() {
            this.$vs.loading();
            this.$http.get("/api/wms/v1/canvas/unloading/check-data-form/" + this.id)
            .then((resp) => {
                if (resp.code == 200) {
                    this.reqCode = resp.data.request_doc
                    this.handoverCode = resp.data.handover_doc
                    this.unlCode = resp.data.unloading_doc
                    this.territories = resp.data.territories.label
                    this.warehouse = resp.data.warehouse
                    this.sales = resp.data.sales.label
                    this.requestDate = resp.data.request_date
                    this.loadingDate = resp.data.loading_date
                    this.unloadingDate = resp.data.unloading_date
                    this.referenceDataLines = resp.data.reference_data_lines
                    this.dataLines = resp.data.data_lines
                    this.referenceMissingLines = resp.data.reference_missing_lines
                    this.missingDataLines = resp.data.missing_data_lines

                    for (let i = 0; i < this.dataLines.length; i++) {
                        for (let j = 0; j < this.dataLines[i].add_line.length; j++) {
                            if (this.dataLines[i].add_line[j].unit) {
                                this.onChangeHu("normal", i, j, this.dataLines[i].add_line[j].unit)
                            }
                        }
                    }

                    if (this.missingDataLines.length) {
                        for (let i = 0; i < this.missingDataLines.length; i++) {
                            for (let j = 0; j < this.missingDataLines[i].add_line.length; j++) {
                                if (this.missingDataLines[i].add_line[j].unit) {
                                    this.onChangeHu("missing", i, j, this.missingDataLines[i].add_line[j].unit)
                                }
                            }
                        }
                    }

                    this.$vs.loading.close();
                } else {
                    this.$vs.loading.close();
                }
            })
            .catch(error => {
                console.log(error)
            });
        },
        handleBack() {
            this.$router.push({
                name: "canvas.unloading",
                params: {status: 1}
            });
        },
        handleSubmit() {
            let message = ""
            let skus = []
            let missingSkus = []
            this.dataLines.forEach(val => {
                let addLines = []

                val.add_line.forEach((idx) => {
                    if (!idx.status) {
                        message = "please select item status for item "+val.item_name
                        return
                    }

                    if (!idx.unit) {
                        message = "please select HU for item "+val.item_name
                        return
                    }

                    if (idx.qty < 1) {
                        message = "quantity for item "+val.item_name+" must be greater than zero"
                        return
                    }

                    if (!idx.batch) {
                        message = "please select batch for item "+val.item_name
                        return
                    }

                    if (!idx.warehouse_area_code) {
                        message = "please select warehouse area for item "+val.item_name
                        return
                    }

                    addLines.push({
                        putaway_id: idx.putaway_id ? idx.putaway_id : 0,
                        status: idx.status,
                        unit: idx.unit,
                        qty: Number(idx.qty),
                        batch: idx.batch,
                        warehouse_area_code: idx.warehouse_area_code,
                    })
                })

                skus.push({
                    unloading_id: val.unloading_id ? val.unloading_id : 0,
                    sku_code: val.item_code,
                    add_lines: addLines,
                })
            })

            if (this.missingDataLines.length > 0) {
                this.missingDataLines.forEach(val => {
                    let addLines = []

                    val.add_line.forEach(idx => {
                        if (!idx.unit) {
                            message = "please select HU for missing item "+val.item_name
                            return
                        }

                        if (idx.qty < 1) {
                            message = "qty for missing item "+val.item_name+" must be greater than zero"
                            return
                        }

                        if (!idx.batch) {
                            message = "please select batch for missing item "+val.item_name
                            return
                        }

                        if (!idx.warehouse_area_code) {
                            message = "please select warehouse area for missing item "+val.item_name
                        }

                        addLines.push({
                            putaway_id: idx.putaway_id ? idx.putaway_id : 0,
                            unit: idx.unit,
                            qty: Number(idx.qty),
                            batch: idx.batch,
                            warehouse_area_code: idx.warehouse_area_code,
                        })
                    })

                    missingSkus.push({
                        unloading_id: val.unloading_id ? val.unloading_id : 0,
                        sku_code: val.item_code,
                        add_lines: addLines,
                    })
                })
            }

            if (message != "") {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
                return false;
            }

            let param = {
                skus: skus,
                missing_skus: missingSkus,
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to save this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.put("/api/wms/v1/canvas/unloading/save-putaway-data/" + this.id, param)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: `Success`,
                                text: "Successfully update putaway's data",
                            });
                            this.handleBack()
                            this.draw++;
                        } else {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: `Something went wrong`,
                                text: resp.message,
                            });
                        }
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                        this.$vs.dialog({
                            color: "danger",
                            title: `Something went wrong`,
                            text: error,
                        });
                    });
                }
            });
        },
        onChangeStatus(val, index, indexAddLine) {
            this.dataLines[index].add_line[indexAddLine].warehouse_area_code = null

            let param = {
                warehouse_id: this.warehouse ? this.warehouse.id : 0,
                item_status: val,
            }

            this.$http.post("/api/wms/v1/canvas/unloading/get-storage-option", param)
            .then(resp => {
                if (resp.code == 200) {
                    if (resp.data != []) {
                        this.dataLines[index].add_line[indexAddLine].option_warehouse_area = resp.data
                    } else {
                        this.dataLines[index].add_line[indexAddLine].option_warehouse_area = []
                    }
                } else {
                    this.dataLines[index].add_line[indexAddLine].option_warehouse_area = []
                }
            })
            .catch(error => {
                console.log(error)
            });
        },
        onChangeHu(lineType, index, idx, val) {
            let skuCode
            if (lineType == "normal") {
                skuCode = this.dataLines[index].item_code
            } else {
                skuCode = this.missingDataLines[index].item_code
            }

            this.$http.get("/api/wms/v1/canvas/unloading/get-amount-uom", {
                params: {
                    sku_code: skuCode,
                    unit: val,
                }
            })
            .then(resp => {
                if (resp.code == 200) {
                    if (lineType == "normal") {
                        this.dataLines[index].add_line[idx].qty_uom = this.handleUpdateFormat(resp.data)
                    } else {
                        this.missingDataLines[index].add_line[idx].qty_uom = this.handleUpdateFormat(resp.data)
                    }

                    this.renderUom = false
                    this.$nextTick(() => (this.renderUom = true));
                }
            })
            .catch(error => {
                console.log(error)
            });
        },
        onChangeQty(lineType, index, idx, val) {
            if (typeof val === 'string') {
                val = val.trim();
                val = val.replace(/\./g, '');
                val = val.split(',')[0];
            }

            let parsedVal = parseInt(val, 10);
            if (isNaN(parsedVal)) {
                parsedVal = 0;
            }

            if (parsedVal < 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Qty must be greater than zero",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
                if (lineType == "normal") {
                    this.dataLines[index].add_line[idx].qty = 0
                } else {
                    this.missingDataLines[index].add_line[idx].qty = 0
                }
                return
            }

            if (lineType == "normal") {
                this.dataLines[index].add_line[idx].qty = parsedVal
            } else {
                this.missingDataLines[index].add_line[idx].qty = parsedVal
            }
        },
        removeRow(lineType, index, indexAddLine) {
            if (lineType == "normal") {
                this.dataLines[index].add_line.splice(indexAddLine, 1);
            } else {
                this.missingDataLines[index].add_line.splice(indexAddLine, 1)
            }
        },
        addRow(lineType, index) {
            if (lineType == "normal") {
                this.dataLines[index].add_line.push({
                    putaway_id: 0,
                    status: "Not picked yet",
                    unit: null,
                    qty: 0,
                    batch: null,
                    option_warehouse_area: [],
                    warehouse_area_code: null,
                });
            } else {
                this.missingDataLines[index].add_line.push({
                    putaway_id: 0,
                    unit: null,
                    qty: 0,
                    batch: null,
                    warehouse_area_code: null,
                })
            }
        },
    },
    watch: {},
    computed: {
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
    },
}
</script>